



import {
    defineComponent,
    onMounted,
    reactive,
    set,
    toRefs,
} from "@vue/composition-api";
import decamelize from 'decamelize-keys-deep'
import camelcase from 'camelcase-keys-deep'

export default defineComponent({
    // 1: 新增业务类型; 2: 新增摄影
    props: {
        type: {
            type: String,
            default: '1'
        }
    },
    setup(props, context) {
        let { midTypeList } = useMidTypes(context);

        return {
            midTypeList,
            ...useConfig(context, midTypeList, props),
        };
    },
});

function useMidTypes(context) {
    const state = reactive({
        midTypeList: [],
    });

    let getMidTypes = async () => {
        let { getMidTypes } = context.root.api;
        let data = await getMidTypes();

        state.midTypeList = data;
    };

    onMounted(() => {
        getMidTypes();
    });

    return toRefs(state);
}

function useConfig(context, midTypeList, props) {
    const {
        $route: {
            params: { type },
        },
    } = context.root;

    const level = ["S", "A", "B", "C", "D"];

    const state = reactive({
        form: {
            businessName: "",
            type: props.type,
            checkProcess: 1,
            checkTimes: undefined,
            priceConfig: [],
        },
        pageType: type,
        levelList: level
    });

    const midTypesCheckChange = async (item, isCheck) => {
        let { type: mIdtype, name } = item
        let { api, $message, $route: { query: { id } }  } = context.root;

        let isExist = state.form.priceConfig.find(config => config.mId === item.type)

        if(isExist && type !== 'add') {
            let data = await api.hasUseMidType({
                type: props.type,
                midType: mIdtype,
                businessType: id
            })

            if(typeof data !== "object") {
                const msg = `存在${data}条素材类型为“${name}”的待审项，无法删除请将待审项审核通过，或回退至“视觉审核”待审，再尝试修改配置`
                $message.error(msg)

                throw new Error(msg);
            }
        }

        midTypesChange(item, isCheck)
    }

    const midTypesChange = (item, isCheck) => {
        const form = state.form;

        // 添加勾选项
        if(isCheck) {
            form.priceConfig.push({
                mId: item.type,
                isPrice: '0',
                levels: [{}]
            })
        }else {
            let idx = form.priceConfig.findIndex(config => config.mId === item.type)
            ~idx && form.priceConfig.splice(idx, 1)
        }
    };

    const getMidTypeName = (id) => {
        const type = midTypeList.value.find((item) => item.type === id);

        if (type) {
            return type.name;
        }
    };

    const getNextLevel = (item) => {
        return level[item.levels.length];
    };

    const addLevel = (item) => {
        item.levels.push({})
    };

    const formatParams = (params) => {
        params = JSON.parse(JSON.stringify(params));
        params.midTypes = params.priceConfig.map(item => item.mId).join(',');
        params.type = props.type

        let newConfig = {}
        params.priceConfig.forEach(item => {
            newConfig[item.mId] = {}

            item.levels.forEach((level, idx) => {
                let levelName = state.levelList[idx]

                newConfig[item.mId][levelName] = decamelize(level)
            })

            newConfig[item.mId].is_level = item.isPrice
        })

        params.priceConfig = JSON.stringify(newConfig);

        return params;
    };

    const getBusinessDetail = async () => {
        let {
            api,
            $route: {
                query: { id },
            },
        } = context.root;
        
        if (id || +props.type === 2 || +props.type === 3 ||+props.type == 4) {
            let apiName = 'getBusinessDetail'
            let type = ''
            switch (+props.type) {
                case 2:
                    // apiName = 'getProgressPhotoWorklist'
                    apiName = 'getProgressBusinesslist',
                    type = '3'
                    break;
                case 3:
                    // apiName = 'getContributionWorkConfig'
                    apiName = 'getProgressBusinesslist',
                    type = '2'
                    break;
                case 4:
                    // apiName = 'getContributionWorkConfig'
                    apiName = 'getProgressBusinesslist',
                    type = '4'
                    break;
            }

            let data = await api[apiName]({ id ,type:type});

            let newConfig = []

            data.priceConfig = JSON.parse(data.priceConfig)

            Object.keys(data.priceConfig).forEach(key => {
                let item = data.priceConfig[key]
                let isPrice = item.is_level
                delete item.is_level

                newConfig.push({
                    mId: key,
                    isPrice,
                    levels: Object.keys(item).map(key => camelcase(item[key]))
                })
            })

            data.priceConfig = newConfig

            state.form = data;
        }
        
        //暂时先注释
        // if (id || +props.type === 2 || +props.type === 3) {
        //     let apiName = 'getBusinessDetail'
        //     switch (+props.type) {
        //         case 2:
        //             apiName = 'getProgressPhotoWorklist'
        //             break;
        //         case 3:
        //             apiName = 'getContributionWorkConfig'
        //             break;
        //     }

        //     let data = await api[apiName]({ id });

        //     let newConfig = []

        //     data.priceConfig = JSON.parse(data.priceConfig)

        //     Object.keys(data.priceConfig).forEach(key => {
        //         let item = data.priceConfig[key]
        //         let isPrice = item.is_level
        //         delete item.is_level

        //         newConfig.push({
        //             mId: key,
        //             isPrice,
        //             levels: Object.keys(item).map(key => camelcase(item[key]))
        //         })
        //     })

        //     data.priceConfig = newConfig

        //     state.form = data;
        // }
    };

    const verifyParams = () => {
        let success = true
        let { businessName = '', checkProcess = '', checkTimes, priceConfig } = state.form
        let midTypes = priceConfig
        const { $message } = context.root

        if(+props.type === 1 && (businessName === '' || businessName.length > 15)) {
            $message.error('请输入业务名称')
            success = false
        }else if(!midTypes.length) {
            $message.error('请选择可征集素材类型')
            success = false
        }else if(checkProcess === '') {
            $message.error('请选择视觉审核流程')
            success = false
        }else if(+state.form.checkProcess === 2 && (checkTimes === '' || checkTimes === undefined)) {
            $message.error('请输入或审人数(2-10)')
            success = false
        }else {
            priceConfig.forEach(item => {
                let typeName = getMidTypeName(item.mId)
                let isLevel = item.isPrice
                let mId = item.mId

                if(!success) return
                if(isLevel === undefined ||isLevel === '') {
                    $message.error(`请选择${typeName}的定价方式`)
                    success = false
                }else {
                    item.levels.forEach(item => {
                        if(+isLevel === 0) {
                            if(item.acceptancePrice === '' || item.acceptancePrice === undefined) {
                                $message.error(`请输入 ${typeName}-${level}级-买断定价`)
                                success = false
                            }else if(mId !== 'th_icon' && (item.userSplitRate === '' || item.userSplitRate === undefined)) {
                                $message.error(`请输入 ${typeName}-${level}级-默认分成比例`)
                                success = false
                            }else if(item.rewardMoney === '' || item.rewardMoney === undefined) {
                                $message.error(`请输入 ${typeName}-${level}级-奖励金`)
                                success = false
                            }

                            if(!success) return
                        }

                        if(item.levelStandard === '' || item.levelStandard === undefined) {
                            $message.error(`请输入 ${typeName}-${level}级-评级标准`)
                            success = false
                        }else if(item.samplePics === '' || item.samplePics === undefined) {
                            $message.error(`请上传 ${typeName}-${level}级-标准案例`)
                            success = false
                        }
                    })
                }
            })
        }

        return success
    }

    const businessAdd = async () => {
        let {
            $router
        } = context.root;
        if(!verifyParams()) return

        await context.root.api.businessAdd(formatParams(state.form));

        if(!+props.type) {
            context.root.$alert('创建成功，请将新增业务类型权限分配给使用人', '提示', {
                center: true,
                confirmButtonText: '确定',
                callback: () => {
                    $router.back()
                }
            })
        }else {
            context.root.$message.success("保存成功");
        }
    };

    const businessEdit = async () => {
        let {
            api,
            $route: {
                query: { id },
            },
            $alert,
            $router
        } = context.root;

        if (id) {
            if(!verifyParams()) return
            await api.businessEdit({ id, ...formatParams(state.form) });

            await $alert("提交成功 修改后的审核流将会在新生成的待审项生效 （旧待审项无法修改）", "提交成功", {
                center: true,
                confirmButtonText: "确定"
            });

            $router.back()
        }
    };

    const deleteLevel = (item, level) => {
        item.levels.splice(item.levels.indexOf(level), 1)
    }

    onMounted(() => {
        getBusinessDetail();
    });

    return {
        businessAdd,
        getNextLevel,
        addLevel,
        getMidTypeName,
        businessEdit,
        deleteLevel,
        ...toRefs(state),
        midTypesCheckChange
    };
}
